import type { Progress } from '../features/plans/api'

export function ProgressBar({ progress, label }: { progress: Progress; label: string }) {
  // An empty group reports no percentage at all: showing 0% would imply
  // outstanding work where there is none.
  if (progress.total === 0) {
    return <span className="muted">No items</span>
  }

  const percent = progress.percentComplete ?? 0

  return (
    <div className="progress">
      <div
        className="progress-track"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`${label} progress`}
      >
        <div
          className={progress.isAtRisk ? 'progress-fill at-risk' : 'progress-fill'}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span className="progress-text">
        {progress.resolved} of {progress.total} · {percent}%
        {progress.overdue > 0 ? (
          <strong className="overdue"> · {progress.overdue} overdue</strong>
        ) : null}
        {progress.overdue === 0 && progress.atRisk > 0 ? (
          <span className="at-risk-text"> · {progress.atRisk} due soon</span>
        ) : null}
      </span>
    </div>
  )
}
